import React from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';

const Wrapper = Flex.extend`
  width: 100%;
  height: 400px;
  background-image: url('/images/about/gotoshop.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  ${media.w800`
    background-image: url('/images/about/m_gotoshop.jpg');
    height: 390px;
  `}
`;

const DescWrapper = styled.div`
  text-align: center;
`;

const Title = styled.div`
  margin: 0 auto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 3.6px;
  color: #333333;

  ${media.mobile`
    font-size: 18px;
  `}
`;

const SubTitle = styled.div`
  margin: 64px auto 0;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #555555;

  ${media.mobile`
    font-size: 16px;
  `}
`;

const Desc = SubTitle.extend`
  margin: 20px auto 30px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;

  & .mobile.hidden {
    display: block;
  }
  & .mobile.show {
    display: none;
  }

  ${media.mobile`
    font-size: 14px;

    & .mobile.hidden {
      display: none;
    }
    & .mobile.show {
      display: block;
    }
  `}
`;

const Btn = styled.button`
  width: 160px;
  height: 45px;
  padding: 0px 25px;
  background: #fff;
  color: #aaaaaa;
  border: 1px solid #eeeeee;
  border-radius: 25px;
  font-family: Lato;
  margin: 30px auto 0;
  font-size: 14px;
  letter-spacing: 0.7px;
  cursor: pointer;
  
  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
  }

  ${media.mobile`
    width: 154px;
    margin-top: 30px;
    font-size: 13px;
  `}
`;

const Bottom = () => (
    <Wrapper>
      <DescWrapper>
        <Title>GO TO SHOP</Title>
        <SubTitle>온라인 쇼핑</SubTitle>
        <Desc>
          <div className="mobile hidden">
            미국 브랜드 베이베디디(Babydeedee)를 구름바이에이치<br/>
            온라인 몰에서 만나보세요!
          </div>

          <div className="mobile show">
            미국 브랜드<br/>
            베이베디디(Babydeedee)를<br/>
            구름바이에이치<br/>
            온라인 몰에서 만나보세요!
          </div>
        </Desc>
        <a href="http://www.gurmbyh.com/product/list.html?cate_no=115" target="_blank" rel="noopener noreferrer"><Btn>SHOP NOW</Btn></a>
      </DescWrapper>
    </Wrapper>
);

export default Bottom;



// WEBPACK FOOTER //
// ./src/components/About/Bottom.js